import $ from 'jquery'
import store_config from "@/store/mods/parametres/config"
import ManageModeleExamen from '@/views/parametres/configs/param-modele-examen/manage-modele-examen'

export default {
    name: 'liste-modele-examens',
    components: {
        ManageModeleExamen
    },
    props: {
        selected_examen: Object,
        user_info: Object,
        active_role: Object,
    },
    data() {
        return {
            mdl_loading: true,
            mdl_empty: false,
            mdl_error: false,
            liste_modeles: [],
            mdl_toggler: 0,
            is_edit: false,

            fields: [
				{ key: 'modele', label: 'Modèle d\'examen' }, { key: 'auteur', label: 'Auteur' },
                { key: 'statut', label: 'Statut' }, { key: 'actions', label: 'Action.s' } 
			],
			filter: "",
			perPage: -1,
			currentPage: 1,
        }
    },

    computed: {

    },

    mounted() {
        this.fetchModeleExamen()
    },
    
    methods: {
        addModeleExamen() {
            this.mdl_toggler = (this.mdl_toggler == 0)?1:0
            this.is_edit = false
            $('.add-mdl-examen').modal('show')
        },

        fetchModeleExamen() {
            this.mdl_loading = true

            const data = {
                type_examen_id: this.selected_examen.id
            }
            store_config.getListeModeleExamens(data).then((response) => {
                this.liste_modeles = response
                if (response.length == 0) {
                    this.mdl_empty = true
                } else {
                    this.mdl_empty = false
                }
                this.mdl_loading = false
            }).catch(() => {
                this.mdl_loading = false
                this.mdl_error = true
            })
        },

        configurer(data) {
            console.log(">> d; ",data);
            this.$emit('emitGotoComp', 'liste-champs')
            this.$emit('emitSetSelectedModele', data)
        },
    }
}